/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const cs_just_added_to_cart = /** @type {(inputs: {}) => string} */ () => {
	return `Přidali jste do košíku`
};

const da_just_added_to_cart = /** @type {(inputs: {}) => string} */ () => {
	return `Du har tilføjet til kurven`
};

const de_just_added_to_cart = /** @type {(inputs: {}) => string} */ () => {
	return `Sie haben zum Warenkorb hinzugefügt`
};

const en_just_added_to_cart = /** @type {(inputs: {}) => string} */ () => {
	return `You just added to your cart `
};

const es_just_added_to_cart = /** @type {(inputs: {}) => string} */ () => {
	return `Has añadido al carrito`
};

const fr_just_added_to_cart = /** @type {(inputs: {}) => string} */ () => {
	return `Vous avez ajouté au panier`
};

const hu_just_added_to_cart = /** @type {(inputs: {}) => string} */ () => {
	return `Hozzáadtad a kosárhoz`
};

const it_just_added_to_cart = /** @type {(inputs: {}) => string} */ () => {
	return `Hai aggiunto al carrello`
};

const nl_just_added_to_cart = /** @type {(inputs: {}) => string} */ () => {
	return `Je hebt toegevoegd aan winkelwagen`
};

const pl_just_added_to_cart = /** @type {(inputs: {}) => string} */ () => {
	return `Dodano do koszyka`
};

const pt_just_added_to_cart = /** @type {(inputs: {}) => string} */ () => {
	return `Você adicionou ao carrinho`
};

const sv_just_added_to_cart = /** @type {(inputs: {}) => string} */ () => {
	return `Du har lagt till i kundvagnen`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "cs" | "da" | "de" | "en" | "es" | "fr" | "hu" | "it" | "nl" | "pl" | "pt" | "sv" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
export const just_added_to_cart = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.just_added_to_cart(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("just_added_to_cart", locale)
	if (locale === "cs") return cs_just_added_to_cart(inputs)
	if (locale === "da") return da_just_added_to_cart(inputs)
	if (locale === "de") return de_just_added_to_cart(inputs)
	if (locale === "en") return en_just_added_to_cart(inputs)
	if (locale === "es") return es_just_added_to_cart(inputs)
	if (locale === "fr") return fr_just_added_to_cart(inputs)
	if (locale === "hu") return hu_just_added_to_cart(inputs)
	if (locale === "it") return it_just_added_to_cart(inputs)
	if (locale === "nl") return nl_just_added_to_cart(inputs)
	if (locale === "pl") return pl_just_added_to_cart(inputs)
	if (locale === "pt") return pt_just_added_to_cart(inputs)
	return sv_just_added_to_cart(inputs)
};